export default notesType =>
  ["accounting", "internal", "external"].includes(notesType);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/isInternalOrExternalNote.js